export default __webpack_public_path__ + "static/media/015_photo.45b1dcb8.jpg";